export default class AiAssistantService {

}